import React from "react";
import styles from "./Pagination.module.css";
import { Button } from "../../atoms/Button/Button";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

interface NotificationProps {
  handlePrevPage: () => void;
  handleNextPage: () => void;
  state: any;
}

export const Pagination: React.FC<NotificationProps> = ({
  handlePrevPage,
  handleNextPage,
  state,
}) => {
  return (
    <div className={styles.paginationControls}>
      <Button
        onClick={handlePrevPage}
        disabled={state.pagination.currentPage <= 1}
      >
        <MdKeyboardArrowLeft className="inline" size={20} />
      </Button>
      <div className="flex flex-col">
        <span>
          Página {state.pagination.currentPage} de {state.pagination.totalPages}
        </span>
        <span>{state.pagination.totalResults} resultados</span>
      </div>
      <Button
        onClick={handleNextPage}
        disabled={state.pagination.currentPage >= state.pagination.totalPages}
      >
        <MdKeyboardArrowRight className="inline" size={20} />
      </Button>
    </div>
  );
};
